import { gql } from "@apollo/client";

export default gql`
  mutation DeleteComment($commentId: ObjectId!, $targetId: ObjectId) {
    removeComment(id: $commentId, targetId: $targetId)
  }
`;
